// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__Mmb0a","column":"styles_column__qRdFm"};